import Pristine from 'pristinejs';

export default {
    init() {
        
    }
}